import React, { useEffect, useState } from 'react'

import {
    FileExcelFilled,
    FileExcelOutlined,
    UploadOutlined
} from '@ant-design/icons';

import {
    Steps,
    message,
    Form,
    Button,
    Input,
    Space,
    DatePicker,
    Row,
    Col,
    Select,
    Switch
} from 'antd';

import Dragger from 'antd/lib/upload/Dragger';
import { useSelector } from 'react-redux';
import { useForm } from 'antd/lib/form/Form';

import { createUploaderProps } from '../../Functions';
import DrawerResume from '../DrawerResume';
import { useApi } from '../../../../Utils';
import moment from 'moment';

export default function WarehouseInjectorDocuments({ rut = '96942690', rsocial = 'GRETA CHILE SpA', documento = '', resetAll, postProcessing = false, setMainLoading }: any) {
    const [step,] = useState(0)
    const { token } = useSelector((state: any) => state)
    const [form] = useForm()
    // form.setFieldValue('postProcessing', postProcessing)

    const props = createUploaderProps(`${rut}:${documento}`, token, form, '.xlsx', 2000) // , undefined, undefined, undefined, postProcessing
    const { data: vendorsData, loading: _loadingVendors } = useApi<any>('get', 'v3/gestion/vendors')
    const { data: warehousesData, loading: _loading } = useApi<any>('get', 'v3/gestion/warehouses')
    const { data: businessUnitsData, loading: _loadingBU } = useApi<any>('get', 'v3/gestion/businessUnits')
    const { data: uploadedManual, loading: _uploadedManual, fetch: uploadManual, errors: errorsManual } = useApi<any>('post', 'v3/sync/injector/59323730', {
        requiredToken: true,
        onRequest: true
    })

    const [vendors, setVendors] = useState<string[]>([])
    const [warehouses, setWarehouses] = useState<string[]>([])
    const [businessUnits, setBusinessUnits] = useState<string[]>([])

    useEffect(() => {
        if (vendorsData?.data) {
            setVendors(vendorsData.data)
        }
    }, [vendorsData])

    useEffect(() => {
        if (warehousesData?.data) {
            setWarehouses(warehousesData.data)
        }
    }, [warehousesData])

    useEffect(() => {
        if (businessUnitsData?.data) {
            setBusinessUnits(businessUnitsData.data)
        }
    }, [businessUnitsData])

    const customBeforeUpload = (file: any) => {
        // Detenemos el upload automático
        const newFileList = [file];
        form.setFieldsValue({ archivo: newFileList });
        return false;
    };

    const handleSubmit = async (values: any) => {
        setMainLoading(true)
        console.log('Valores del form:', values);
        const fileList = values.archivo;
        const formData = new FormData();
        fileList.forEach((file: any) => {
            formData.append('oc', file.originFileObj || file);
        });
        formData.append('bodega', values.warehouse)
        formData.append('vendor', values.vendor)
        formData.append('cc', values.businessUnit)
        if (values.glosa) {
            formData.append('glosa', values.glosa)
        }
        if (values.comentario) {
            formData.append('comentario', values.comentario)
        } 

        // console.log(formData)

        // Aquí iría el fetch o axios
        await uploadManual(formData)
        // setMainLoading(true)
    };

    useEffect(() => {
        if (setMainLoading) {
            setMainLoading(_uploadedManual)
        }
    }, [_uploadedManual, setMainLoading])

    useEffect(() => {
        if (errorsManual.length) {
            for (const _error of errorsManual) {
                message.error(_error)
            }
            console.log(errorsManual)
        }
    }, [errorsManual])

    useEffect(() => {
        console.log(uploadedManual)
        if (uploadedManual && uploadedManual.status === 'success') {
            message.success('OC Minoristas cargadas con éxito.')
            resetAll()
        }
        // console.log(uploadedManual)
    }, [uploadedManual, resetAll])

    const [data, setData] = useState<any[]>([])

    return <Row className="WarehouseInjector--Row">
        <DrawerResume data={data} modify={false} price={false} resetAll={resetAll} />
        <Col span={24}>
            <Steps current={step} items={[
                { title: 'Solicitud', description: 'Detalle en Excel' },
                { title: 'Resumen', description: 'Validación y guardado' }
            ]} />

            {step === 0 && <div className="WarehouseInjector--Row--Step">
                <Row gutter={16}>
                    {!postProcessing && <Col xs={24} md={9} style={{
                        gap: 16,
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {<Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <FileExcelFilled />
                            </p>
                            <p className="ant-upload-text">Selecciona el archivo para inyectar</p>
                            <p className="ant-upload-hint">
                                En este primer paso, debes cargar archivos exclusivamente de <strong>{documento}</strong> para procesar en Flexline ERP. <i>Se permite un máximo de 2.000 lineas por documento.</i>
                            </p>
                        </Dragger>}

                        <Button icon={<FileExcelOutlined />} target='_blank' type='ghost' block size='large' href={`https://app.bodegaenlinea.cl/examples/Ejemplo%20de%20Carga%20${documento}.xlsx`}>
                            Descargar <strong> Excel </strong> de ejemplo
                        </Button>
                    </Col>}
                    <Col xs={24} md={!postProcessing ? 15 : 24}>
                        <Form form={form} layout={'horizontal'} className="InjDocuments__Form" initialValues={{
                            date: moment(),
                            isDistributed: false
                        }} onFinish={(values) => {
                            // setData(values.orders)
                            // console.log(
                            //     values.orders.map((item: any) => {
                            //         item.formConfig = {
                            //             date: values.date,
                            //             warehouse: values.warehouse,
                            //             businessUnit: values.businessUnit,
                            //             glosa: values.glosa || ' ',
                            //             comentario: values.comentario || ' ',
                            //             limitItems: values.limitItems,
                            //             rut,
                            //             rsocial
                            //         }
                            //         console.log(item.detail.filter(d => `${d.DESC}`.trim().length === 0))
                            //         return item
                            //     })
                            // )

                            if (!postProcessing) {
                                setData(values.orders.map((item: any) => {
                                    item.formConfig = {
                                        date: values.date,
                                        warehouse: values.warehouse,
                                        businessUnit: values.businessUnit,
                                        glosa: values.glosa || ' ',
                                        comentario: values.comentario || ' ',
                                        limitItems: values.limitItems,
                                        isDistributed: values.isDistributed,
                                        rut,
                                        rsocial
                                    }
                                    return item
                                }))
                            } else {
                                handleSubmit(values)
                            }  
                        }}>
                            {postProcessing && <>
                                <Button icon={<FileExcelOutlined />} target='_blank' type='ghost' block size='large' href={`https://app.bodegaenlinea.cl/examples/Ejemplo%20de%20Carga%20${documento}.xlsx`}>
                                    Descargar <strong> Excel </strong> de ejemplo
                                </Button>
                                <br />
                                <br />
                            </>}
                            {postProcessing && <Form.Item
                                label="Archivo"
                                name="archivo"
                                valuePropName="fileList"
                                getValueFromEvent={e => Array.isArray(e) ? e : e?.fileList}
                            >
                                <Dragger beforeUpload={customBeforeUpload} multiple={false}>
                                    <p className="ant-upload-drag-icon"><UploadOutlined /></p>
                                    <p className="ant-upload-text">Haz click o arrastra un archivo</p>
                                </Dragger>
                            </Form.Item>}
                            
                            <Form.Item name="date"
                                label="Fecha de solicitud"
                                tooltip="Elige una fecha para cursar la solicitud de consumo, esta fecha será con la cuál calcularemos el Inventario en Bodega."
                                required
                                rules={[
                                    { required: true, message: 'Debes seleccionar una fecha para la solicitud' }
                                ]}
                            >
                                <DatePicker placeholder='YYYY-MM-DD' />
                            </Form.Item>
                            <Form.Item name="warehouse" label="Bodega" required rules={[
                                { required: true, message: 'Debes seleccionar una bodega para la solicitud' }
                            ]}>
                                <Select
                                    disabled={_loading}
                                    showSearch
                                    allowClear
                                    style={{
                                        width: '100%',
                                        minWidth: 248
                                    }}
                                    placeholder='Selecciona una bodega...'
                                >
                                    {warehouses.map(field => (
                                        <Select.Option value={field} key={field}>{field}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item name="businessUnit" label="Centro de Costo" required rules={[
                                { required: true, message: 'Debes seleccionar un centro de costo para la solicitud' }
                            ]}>
                                <Select
                                    disabled={_loadingBU}
                                    showSearch
                                    allowClear
                                    style={{
                                        width: '100%',
                                        minWidth: 248
                                    }}
                                    placeholder='Selecciona un centro de costo...'
                                >
                                    {businessUnits.map(field => (
                                        <Select.Option value={field} key={field}>{field}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item name="vendor" label="Vendedor" required rules={[
                                { required: true, message: 'Debes seleccionar un vendedor para la solicitud' }
                            ]}>
                                <Select
                                    disabled={_loadingVendors}
                                    showSearch
                                    allowClear
                                    style={{
                                        width: '100%',
                                        minWidth: 248
                                    }}
                                    placeholder='Selecciona un vendedor...'
                                >
                                    {vendors.map(field => (
                                        <Select.Option value={field} key={field}>{field}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            {documento === 'SOLICITUD INY' && <>
                                <Form.Item
                                    name="isDistributed"
                                    label="Consumo Distribuido"
                                    tooltip='Esta configuración permitirá procesar la Solicitud de Consumo como un Consumo Distribuido, para separar en función del pedido.'
                                    valuePropName="checked"
                                >
                                    <Switch />
                                </Form.Item>
                            

                            <Form.Item name="glosa" label="Glosa" rules={[
                                { max: 150, message: 'No debes exceder los 150 caracteres.' }
                            ]}>
                                <Input.TextArea showCount maxLength={150} />
                            </Form.Item>

                            <Form.Item name="comentario" label="Comentario" rules={[
                                { max: 300, message: 'No debes exceder los 300 caracteres.' }
                            ]}>
                                <Input.TextArea showCount maxLength={300} />
                            </Form.Item>
                            
                            </>}

                            <Form.List name="orders" rules={[
                                // { required: true, message: 'Necesitas cargar al menos un archivo eOC' }
                                {
                                    validator: async (_, orders) => {
                                        if (!postProcessing && (!orders || orders.length < 1)) {
                                            message.error('Necesitas cargar al menos un archivo eOC')
                                            return Promise.reject(new Error('Necesitas cargar al menos un archivo eOC'))
                                        }
                                    }, message: 'Necesitas cargar al menos un archivo eOC'
                                }
                            ]}>
                                {(fields) => (
                                    <>
                                        {fields.map((field, i) => (
                                            <Space size={0} key={`${(form.getFieldValue('orders') ?? [])[field.key]?.path}`} style={{
                                                // display: 'flex',
                                                // marginBottom: 8,
                                                // justifyContent: 'space-between',
                                                // alignItems: 'flex-start',
                                                width: '100%',
                                                marginBottom: i === fields.length - 1 ? 48 : 0
                                            }}>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'path']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'filename']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    label="eOC Número"
                                                    name={[field.name, 'number']}
                                                    help={`${(form.getFieldValue('orders') ?? [])[field.key]?.filename}`}
                                                    tooltip='El número de la eOC debe ser el mismo que el número de la eOD'
                                                    rules={[
                                                        { pattern: /^[0-9]+$/, message: 'Para el número de la eOC, solo se permiten números' },
                                                        {
                                                            validator: (_, value) => {
                                                                const _orders = form.getFieldValue('orders') ?? [];
                                                                const _order = _orders.filter((o: any) => o.number === value)

                                                                if (_order.length > 1) {
                                                                    message.error({
                                                                        content: 'Existen eOC con el mismo número, revísalas antes de continuar.',
                                                                        key: 'order-number-duplicated',
                                                                    })
                                                                    return Promise.reject('Existen eOC con el mismo número, revísalas antes de continuar.')
                                                                }
                                                                return Promise.resolve()
                                                            }, message: 'Existen eOC con el mismo número, revísalas antes de continuar.'
                                                        }
                                                    ]}
                                                >
                                                    <Input type='hidden' />
                                                </Form.Item>
                                            </Space>
                                        ))}
                                    </>
                                )}
                            </Form.List>

                            <Form.Item className="WarehouseInjector--Submit">
                                <Button type="primary" htmlType="submit" size="large">
                                    Continuar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </div>}
        </Col>
    </Row>
}